export const messages = {
  en: {
    listCarFee: {
      fee: 'Fee',
      createFee: 'Create Fee',
      feeItem: 'Fee Item',
      feeFlag: 'Fee Flag',
      feeType: 'Fee Type',
      amountOwed: 'Amount Owed',
      startTime: 'Start Time',
      endTime: 'End Time',
      remark: 'Remark',
      state: 'State',
      operation: 'Operation',
      pay: 'Pay',
      history: 'History',
      cancel: 'Cancel',
      change: 'Change',
      split: 'Split',
      detail: 'Detail',
      preDegrees: 'Pre Degrees',
      curDegrees: 'Cur Degrees',
      price: 'Price',
      additionalAmount: 'Additional Amount',
      algorithm: 'Algorithm',
      usage: 'Usage',
      note1: 'Note: The end time "-" means the fee is not due or the fee collection has ended.',
      note2: 'If the amount owed is -1, it is usually an error in the fee item formula setting, please check.',
      note3: 'Cancel fee process: More operations->Detail, get batch number; Fee list->Cancel fee, search batch number, click apply cancel; Search batch number again, click audit cancel.'
    },
  },
  zh: {
    listCarFee: {
      fee: '费用',
      createFee: '创建费用',
      feeItem: '费用项目',
      feeFlag: '费用标识',
      feeType: '费用类型',
      amountOwed: '应收金额',
      startTime: '建账时间',
      endTime: '应收时间段',
      remark: '说明',
      state: '状态',
      operation: '操作',
      pay: '缴费',
      history: '历史',
      cancel: '取消',
      change: '变更',
      split: '拆分',
      detail: '详情',
      preDegrees: '上期度数',
      curDegrees: '本期度数',
      price: '单价',
      additionalAmount: '附加费',
      algorithm: '算法',
      usage: '用量',
      note1: '注意：应收结束时间“-”表示未到应收时间或收费已结束。',
      note2: '应收金额为-1一般为费用项公式设置出错请检查。',
      note3: '取消费用流程：更多操作->详情，拿到批次号；费用列表->取消费用，搜索批次号，点击申请取消；再次搜索批次号，点击审核取消'
    },
  }
}